import './App.css';
import Panel from './Panel';
import React from 'react';

function App() {
  return (
   <Panel />
  );
}

// function App() {
//   const [] = React.useState(true);

//   return (
//     <>
//       <button>Hide Element Below</button>

//       <div>Toggle Challenge</div>
//     </>
//   );
// }

export default App;
